import { getPathWithRootPath } from '../../Services/common';
import { ModuleData } from '../../Types/containerV2';
import { isImageModuleContent } from '../../Types/containerV2/modules/image';
import './ImageModule.scss';

type ImageModuleProps = {
	module: ModuleData;
};

const ImageModule = ({ module }: ImageModuleProps) => {
	if (!isImageModuleContent(module.content)) {
		return null;
	}

	const { src, alt } = module.content;

	if (!src) {
		return (
			<div className='biz-module biz-image-module'>
				<div className='biz-image-module__placeholder'>
					<span className='biz-image-module__placeholder-icon'>&#128247;</span>
					<span className='biz-image-module__placeholder-text'>No image selected</span>
				</div>
			</div>
		);
	}

	const image = <img className='biz-image-module__img' src={getPathWithRootPath(src)} alt={alt ?? ''} />;

	return <div className='biz-module biz-image-module'>{image}</div>;
};

export default ImageModule;
